import React, { Component } from 'react';

import Configs from 'Configuration';
import FhtFetchUrl from 'Utils/FhtFetchUrl.jsx';

import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Grid,
  Paper,
  Snackbar,
  Typography,
} from '@material-ui/core';

import SnackbarContentWrapper from 'components/SnackbarContentWrapper';

class LinkmeDoctorEligibility extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // Data
      users: [],
      usersIsSaving: false
    };

    this.loadUsers();
  }

  render() {
    console.log(this.state.users);

    return (
      <Box maxWidth={800} margin="auto">
        {this.renderSnackbar()}
        <Typography variant="h3" gutterBottom>Doctors Eligible for Linkme+</Typography>
        <Grid container spacing={3}>
          <Grid item sm={12}>
            <Paper>
              <Box sx={{ padding: 12 }}>
                <Typography variant="h6" gutterBottom>Doctors</Typography>
                <Typography variant="subtitle1" gutterBottom>These are the participating doctors for the Linkme+ program.
                  The doctor's patients will be sent an SMS at the configured interval,
                  and they will receive a Windows notification when they open up the patient's file in the EMR system.</Typography>
                <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "flex-start" }}>
                  {this.state.users.map((user, index) =>
                    <FormControlLabel
                      key={`doctor-checkbox-${index}`}
                      control={
                        <Checkbox
                          checked={user.accountEnabled === 1}
                          onChange={(e) => {
                            const users = this.state.users;
                            users[index].accountEnabled = e.target.checked ? 1 : 0;
                            users[index].isModified = true;
                            this.setState({ users });
                          }}
                          name={`doctor-checkbox-${index}`}
                          color="primary"
                        />
                      }
                      label={
                        <Box sx={{ paddingY: 1 }}>
                          <Typography>{user.firstName} {user.lastname}</Typography>
                          <Typography color="textSecondary">{user.username}</Typography>
                        </Box>
                      }
                    />
                  )}
                </Box>
              </Box>
            </Paper>
          </Grid>
          <Grid container spacing={1} justifyContent="center">
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                onClick={() => this.saveUsers()}
                disabled={this.state.usersIsSaving || !this.state.users.some(user => user.isModified)}
              >
                {this.state.usersIsSaving ? <CircularProgress color="inherit" size={20} /> : "Save"}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    );
  }

  renderSnackbar() {
    return (
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={this.state.openSnackbar}
        autoHideDuration={4000}
        onClose={() => this.setState({ openSnackbar: false })}
      >
        <SnackbarContentWrapper
          onClose={() => this.setState({ openSnackbar: false })}
          variant={this.state.snackbarVariant}
          message={this.state.snackbarMessage}
        />
      </Snackbar>
    );
  }

  async loadUsers() {
    try {
      const usersApi = FhtFetchUrl(Configs.getUsers);
      const doctorsApi = FhtFetchUrl(Configs.getLinkMeDoctors);

      const [response, responseDoctors] = await Promise.all([
        usersApi.get(),
        doctorsApi.get()
      ]);
      
      const doctorsList = Array.isArray(responseDoctors) ? responseDoctors : responseDoctors.data || [];

      const doctorUsernames = new Set(
        doctorsList
          .map(doc => doc.staffExtractEmrUsername?.toLowerCase())
          .filter(Boolean)
      );

      const filteredUsers = response.data.filter(user => {
        const username = user.username?.toLowerCase() || "";
        return doctorUsernames.has(username);
      });
      this.setState({ users: filteredUsers });
    }
    catch (e) {
      this.setState({ snackbarMessage: "Could not get Eligible doctors", snackbarVariant: "error", openSnackbar: true });
    }
  }

  async saveUsers() {
    try {
      const api = FhtFetchUrl(Configs.editUsers);
      this.setState({ usersIsSaving: true });
      const modifiedUsers = this.state.users.filter(user => user.isModified);
      await Promise.all(modifiedUsers.map(user => api.post(user)))
        .then(async () => {
          this.props.GlobalFunctionDisplaySnackbarMessage("Updated eligible doctors", Configs.snackbarVariants.success);
          await this.loadUsers();
        })
        .catch(() => {
          this.props.GlobalFunctionDisplaySnackbarMessage("Error updating doctors", Configs.snackbarVariants.error);
        });

      //this.setState({ snackbarMessage: "Eligible doctors saved successfully", snackbarVariant: "success", openSnackbar: true });
    }
    catch (e) {
      this.setState({ snackbarMessage: "Could not save SMS settings", snackbarVariant: "error", openSnackbar: true });
    }
    finally {
      this.setState({ usersIsSaving: false });
    }
  }
}

export default LinkmeDoctorEligibility;
